/** Moneda del comprobante (montos legales en la moneda de ingreso). */
export function normalizeDocumentCurrency(currency) {
  return currency === 'USD' ? 'USD' : 'PEN';
}

export function documentCurrencySymbol(currency) {
  return normalizeDocumentCurrency(currency) === 'USD' ? 'US$' : 'S/';
}

export function documentCurrencyLabel(currency) {
  return normalizeDocumentCurrency(currency) === 'USD' ? 'USD' : 'PEN';
}

export function formatMoneyInDocumentCurrency(amount, currency) {
  const symbol = documentCurrencySymbol(currency);
  const value = Number(amount || 0).toLocaleString('es-PE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${symbol} ${value}`;
}

/** Totales del resumen mensual: { PEN: n, USD: n } */
export function formatAmountsByCurrency(amountsByCurrency) {
  if (!amountsByCurrency || typeof amountsByCurrency !== 'object') {
    return '';
  }
  const parts = [];
  const pen = Number(amountsByCurrency.PEN);
  const usd = Number(amountsByCurrency.USD);
  if (Number.isFinite(pen) && pen !== 0) {
    parts.push(formatMoneyInDocumentCurrency(pen, 'PEN'));
  }
  if (Number.isFinite(usd) && usd !== 0) {
    parts.push(formatMoneyInDocumentCurrency(usd, 'USD'));
  }
  return parts.join(' · ');
}

export function formatListStatsAmount(stats) {
  if (!stats) return formatMoneyInDocumentCurrency(0, 'PEN');
  const byCur = formatAmountsByCurrency(stats.amounts_by_currency);
  if (byCur) return byCur;
  if (stats.issued_amount != null) {
    return formatMoneyInDocumentCurrency(stats.issued_amount, 'PEN');
  }
  return formatMoneyInDocumentCurrency(0, 'PEN');
}

/** Suma montos de registros emitidos agrupados por moneda del comprobante. */
export function sumIssuedAmountsByCurrency(records, options = {}) {
  const {
    statusField = 'status',
    issuedValue = 'issued',
    amountField = 'total_amount',
    currencyField = 'currency',
  } = options;
  const out = { PEN: 0, USD: 0 };
  (records || []).forEach((row) => {
    if (row?.[statusField] !== issuedValue) return;
    const code = normalizeDocumentCurrency(row?.[currencyField]);
    out[code] += Number(row?.[amountField]) || 0;
  });
  out.PEN = Math.round(out.PEN * 100) / 100;
  out.USD = Math.round(out.USD * 100) / 100;
  return out;
}

/** Texto para cabecera de mes en listados lazy (emitidos por moneda). */
export function formatMonthIssuedAmounts(month) {
  if (!month) return '';
  const byCur = formatAmountsByCurrency(month.amounts_by_currency);
  if (byCur) return `Emitidos ${byCur}`;
  const issued = Number(month.issued_amount);
  if (Number.isFinite(issued) && issued > 0) {
    return `Emitidos ${formatMoneyInDocumentCurrency(issued, 'PEN')}`;
  }
  return '';
}
